import { useCallback } from 'react';
import { posthogTrackEvent, IntegrationEvents } from '@/assets/posthog';

export const useIntegrationsTracking = () => {
  const trackIntegrationViewed = useCallback((integrationType: string, integrationId?: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.INTEGRATION_VIEWED,
      properties: {
        integrationType,
        integrationId,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackIntegrationConnected = useCallback((integrationType: string, integrationId: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.INTEGRATION_CONNECTED,
      properties: {
        integrationType,
        integrationId,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackIntegrationDisconnected = useCallback((integrationType: string, integrationId: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.INTEGRATION_DISCONNECTED,
      properties: {
        integrationType,
        integrationId,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackIntegrationConfigured = useCallback((integrationType: string, configOptions?: Record<string, any>) => {
    posthogTrackEvent({
      event: IntegrationEvents.INTEGRATION_CONFIGURED,
      properties: {
        integrationType,
        configOptions,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackIntegrationTested = useCallback((integrationType: string, testResult: boolean) => {
    posthogTrackEvent({
      event: IntegrationEvents.INTEGRATION_TESTED,
      properties: {
        integrationType,
        testResult,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackBrandAdded = useCallback((brandName: string, integrationType: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.BRAND_ADDED,
      properties: {
        brandName,
        integrationType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackBrandRemoved = useCallback((brandName: string, integrationType: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.BRAND_REMOVED,
      properties: {
        brandName,
        integrationType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackComingSoonViewed = useCallback((integrationType: string) => {
    posthogTrackEvent({
      event: IntegrationEvents.COMING_SOON_VIEWED,
      properties: {
        integrationType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  return {
    trackIntegrationViewed,
    trackIntegrationConnected,
    trackIntegrationDisconnected,
    trackIntegrationConfigured,
    trackIntegrationTested,
    trackBrandAdded,
    trackBrandRemoved,
    trackComingSoonViewed,
  };
};